export const MAX_GPX_BYTES = 10 * 1024 * 1024;
export const ELEVATION_NOISE_THRESHOLD_METERS = 3;
export const SMOOTHING_WINDOW_POINTS = 5;

export function toRadians(value) {
  return value * Math.PI / 180;
}

export function haversine(a, b) {
  const earthRadiusKm = 6371;
  const dLat = toRadians(b.latitude - a.latitude);
  const dLon = toRadians(b.longitude - a.longitude);
  const lat1 = toRadians(a.latitude);
  const lat2 = toRadians(b.latitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 2 * earthRadiusKm * Math.asin(Math.sqrt(h));
}

export function getTicks(min, max, count) {
  const ticks = [];
  const step = (max - min) / Math.max(count - 1, 1);
  for (let index = 0; index < count; index += 1) {
    ticks.push(min + step * index);
  }
  return ticks;
}

export function thinPoints(points, maxPoints) {
  if (points.length <= maxPoints) {
    return points;
  }

  const step = Math.ceil(points.length / maxPoints);
  const thinned = points.filter((_, index) => index % step === 0);
  thinned.push(points[points.length - 1]);
  return thinned;
}

export function parseCssPixels(value, fallback) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed >= 260 ? parsed : fallback;
}

export function formatElevation(value) {
  return `${Math.round(value).toLocaleString()} m`;
}

export function formatDistance(value) {
  return `${value.toFixed(1)} km`;
}

export function round(value) {
  return Math.round(value * 10) / 10;
}

export function debounce(fn, wait) {
  let timeout;
  return function (...args) {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => fn.apply(this, args), wait);
  };
}
